import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Callout, FlexGap, Modal, Paragraph, Subheading } from '@treams/treams-ui';

interface IProps {
	deleting: boolean;
	onConfirm: () => Promise<unknown> | unknown;
	onClose: () => void;
}

export function ConversationRevealDeleteConfirm({ deleting, onConfirm, onClose }: IProps) {
	const { t } = useTranslation();
	const [error, setError] = useState(false);

	const handleConfirm = async () => {
		setError(false);
		try {
			await onConfirm();
			onClose();
		} catch {
			setError(true);
		}
	};

	return (
		<Modal width={450}>
			<Modal.Contents>
				<Subheading>{t('conversations.reveal.settings.deleteConfirmTitle')}</Subheading>
				<Paragraph mt={2}>{t('conversations.reveal.settings.deleteConfirmDescription')}</Paragraph>
				{error ? (
					<Callout color="red" mt={3}>
						{t('conversations.reveal.settings.deleteError')}
					</Callout>
				) : null}
			</Modal.Contents>
			<Modal.Footer>
				<FlexGap gap={8} justifyContent="flex-end" alignItems="center" width="100%">
					<Button small type="alternative" title={t('common.cancel')} onClick={onClose} />
					<Button
						small
						type="destructive"
						title={t('conversations.reveal.settings.deleteConfirmButton')}
						loading={deleting}
						onClick={handleConfirm}
					/>
				</FlexGap>
			</Modal.Footer>
		</Modal>
	);
}
